import { render, staticRenderFns } from "./ModerateImagesApprove.vue?vue&type=template&id=77af5d8e&scoped=true&"
import script from "./ModerateImagesApprove.vue?vue&type=script&lang=js&"
export * from "./ModerateImagesApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77af5d8e",
  null
  
)

export default component.exports